module.exports = __webpack_public_path__ + "img/imgs.0245555f.png";